/* eslint-disable max-len */
import { INTL_IDS } from '@dmi/shared/redux/LossDraft/messages';

export const CHANGE_FORM_FIELD_VALUE = 'app/LossDraft/CHANGE_FORM_FIELD_VALUE';

export const CHANGE_SELECTED_CLAIM_NUMBER = 'app/LossDraft/CHANGE_SELECTED_CLAIM_NUMBER';

export const CHANGE_SELECTED_MESSAGE_ID = 'app/LossDraft/CHANGE_SELECTED_MESSAGE_ID';

export const CHANGE_SELECTED_TAB = 'app/LossDraft/CHANGE_SELECTED_TAB';

export const CHANGE_STEP = 'app/LossDraft/CHANGE_STEP';

export const CHOOSE_DOCUMENT = 'app/LossDraft/CHOOSE_DOCUMENT';
export const CHOOSE_DOCUMENT_CANCELLATION = 'app/LossDraft/CHOOSE_DOCUMENT_CANCELLATION';
export const CHOOSE_DOCUMENT_FAILURE = 'app/LossDraft/CHOOSE_DOCUMENT_FAILURE';
export const CHOOSE_DOCUMENT_SUCCESS = 'app/LossDraft/CHOOSE_DOCUMENT_SUCCESS';

export const DOWNLOAD_ATTACHMENT = 'app/LossDraft/DOWNLOAD_ATTACHMENT';
export const DOWNLOAD_ATTACHMENT_FAILURE = 'app/LossDraft/DOWNLOAD_ATTACHMENT_FAILURE';

export const DOWNLOAD_DOCUMENT = 'app/LossDraft/DOWNLOAD_DOCUMENT';
export const DOWNLOAD_DOCUMENT_FAILURE = 'app/LossDraft/DOWNLOAD_DOCUMENT_FAILURE';

export const FETCH_ATTACHMENT = 'app/LossDraft/FETCH_ATTACHMENT';
export const FETCH_ATTACHMENT_CANCELLED = 'app/LossDraft/FETCH_ATTACHMENT_CANCELLED';
export const FETCH_ATTACHMENT_FAILURE = 'app/LossDraft/FETCH_ATTACHMENT_FAILURE';
export const FETCH_ATTACHMENT_SUCCESS = 'app/LossDraft/FETCH_ATTACHMENT_SUCCESS';

export const FETCH_LOSSDRAFT = 'app/LossDraft/FETCH_LOSSDRAFT';
export const FETCH_LOSSDRAFT_FAILURE = 'app/LossDraft/FETCH_LOSSDRAFT_FAILURE';
export const FETCH_LOSSDRAFT_SUCCESS = 'app/LossDraft/FETCH_LOSSDRAFT_SUCCESS';

export const FETCH_MESSAGES = 'app/LossDraft/FETCH_MESSAGES';
export const FETCH_MESSAGES_FAILURE = 'app/LossDraft/FETCH_MESSAGES_FAILURE';
export const FETCH_MESSAGES_SUCCESS = 'app/LossDraft/FETCH_MESSAGES_SUCCESS';

export const FETCH_MESSAGE_DETAILS = 'app/LossDraft/FETCH_MESSAGE_DETAILS';
export const FETCH_MESSAGE_DETAILS_FAILURE = 'app/LossDraft/FETCH_MESSAGE_DETAILS_FAILURE';
export const FETCH_MESSAGE_DETAILS_SUCCESS = 'app/LossDraft/FETCH_MESSAGE_DETAILS_SUCCESS';

export const POST_MESSAGE = 'app/LossDraft/POST_MESSAGE';
export const POST_MESSAGE_FAILURE = 'app/LossDraft/POST_MESSAGE_FAILURE';
export const POST_MESSAGE_SUCCESS = 'app/LossDraft/POST_MESSAGE_SUCCESS';

export const POST_REPLY = 'app/LossDraft/POST_REPLY';
export const POST_REPLY_FAILURE = 'app/LossDraft/POST_REPLY_FAILURE';
export const POST_REPLY_SUCCESS = 'app/LossDraft/POST_REPLY_SUCCESS';

export const PROCESS_DOCUMENT = 'app/LossDraft/PROCESS_DOCUMENT';
export const PROCESS_DOCUMENT_FAILURE = 'app/LossDraft/PROCESS_DOCUMENT_FAILURE';
export const PROCESS_DOCUMENT_SUCCESS = 'app/LossDraft/PROCESS_DOCUMENT_SUCCESS';

export const REMOVE_ATTACHMENT = 'app/LossDraft/REMOVE_ATTACHMENT';

export const RESET_BANNER_ERROR = 'app/LossDraft/RESET_BANNER_ERROR';
export const RESET_FORM_STATE = 'app/LossDraft/RESET_FORM_STATE';
export const RESET_LOSS_DRAFT_STATE = 'app/LossDraft/RESET_LOSS_DRAFT_STATE';
export const RESET_REQUEST_STATUS = 'app/LossDraft/RESET_REQUEST_STATUS';
export const RESET_SERVICE_ERROR = 'app/LossDraft/RESET_SERVICE_ERROR';
export const RESET_STEP = 'app/LossDraft/RESET_STEP';

export const SET_ATTACHMENT_FILE = 'app/LossDraft/SET_ATTACHMENT_FILE';
export const SET_BANNER_ERROR = 'app/LossDraft/SET_BANNER_ERROR';

export const TOGGLE_ATTACHMENT_DRAWER = 'app/LossDraft/TOGGLE_ATTACHMENT_DRAWER';

export const UPDATE_ATTACHMENTS = 'app/LossDraft/UPDATE_ATTACHMENTS';

export const UPDATE_CLAIM_NUMBERS_READ = 'app/LossDraft/UPDATE_CLAIM_NUMBERS_READ';

export const UPLOAD_ATTACHMENTS_FAILURE = 'app/LossDraft/UPLOAD_ATTACHMENTS_FAILURE';

// Attachment constants

export const ATTACHMENT_BLOCKED_MESSAGE = 'You will need to enable pop-ups in your browser for this site in order to view this content.';
export const FETCH_ERROR_MESSAGE = 'An error has occurred while trying to retrieve your documents. If this issue persists, please call customer service at';

// Screen messages

export const CLOSED_STATUS_MESSAGE = 'Please send a new message if you have questions related to this conversation.';

export const DOWNLOAD_ERROR_MESSAGE = 'Unable to download file. Please try again later.';

export const FETCH_MESSAGES_FAILURE_ERROR_MESSAGE = 'An error has occurred while trying to retrieve your messages.';

export const MESSAGES_ATTACHMENT_UPLOAD_DICTIONARY = {
  description: 'Make sure your document is readable, complete, and includes any signatures if applicable.\n\nIf you are submitting an insurance card, please upload an image of the front and back of the card.',
  headerLabel: 'Add Attachment',
  secondaryHeader: 'Add a document to your message',
};

export const MESSAGES_ATTACHMENT_REVIEW_DICTIONARY = {
  description: 'The document(s) below will be attached and sent with your message. Maximum of 5 files allowed.',
  headerLabel: 'Review Document Upload',
  secondaryHeader: 'Review your document',
};

export const MESSAGES_TABLE_EMPTY_HEADING = 'You haven’t submitted any inquiries yet';
export const MESSAGES_TABLE_EMPTY_MESSAGE = 'Sending a secure message is a convenient and easy way to contact customer service about your claim. Get started here.';
export const MESSAGES_TABLE_TEXT_TOP = 'Send secure messages about your claim. Inquiries will be reviewed as soon as possible.';

export const ERROR_CONFIRMATION_TEXT = 'An error has occured while trying to send your message. For assistance, please call customer service at {{customerServicePhoneNumber}}.';
export const POST_MESSAGE_FAILURE_ERROR_MESSAGE = 'We are unable to send your message at this time';

export const POST_MESSAGE_SUCCESS_MESSAGE = 'Success! We received your message';
export const SUCCESS_CONFIRMATION_TEXT = 'Your message has been submitted and has been referred to the appropriate area for review.';

export const INFO_COPY_DICT = {
  confirmation: [
    {
      text: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
      variant: 'pending',
    },
  ],
};

export const defaultContactInfo = {
  email: 'LossDraft@yourmortgageonline.com',
  extension: 'Ext.6086',
  fax: 'F: 1-847-574-7617',
  heading: 'Contact Information',
  hours: '7AM - 5PM CST, Monday - Friday',
  phone: '1-877-592-0192',
};

// Other

export const ATTACHMENT_DOCUMENT_CATEGORY = 'lossDraft'; // TODO Verify this is the correct category name

export const CLAIMS_DEPT_AUTHOR = 'Claims Dept.';

export const CLAIM_DETAILS_PAGE_HEADER = 'Claim Details';

export const CLAIMS_PROCESS_KEY = 'Claims Process';

export const CLAIMS_PROCESS_MENU = [
  {
    menu: [
      { rowLabel: 'Submit Insurance Claims Check' },
      { rowLabel: 'Submit Insurance Adjusters Report' },
      { rowLabel: 'Submit Contractor(s) Estimate' },
      { rowLabel: 'Receive Initial Disbursement' },
    ],
    title: 'Initial Disbursement',
  },
  {
    menu: [
      { rowLabel: 'Request a Supplemental Disbursement' },
      { rowLabel: 'Request an Inspection' },
      { rowLabel: 'Review Inspection Results' },
      { rowLabel: 'Receive Supplemental Disbursement' },
    ],
    title: 'Supplemental Disbursement',
  },
  {
    menu: [
      { rowLabel: 'Request a Final Disbursement' },
      { rowLabel: 'Request an Inspection' },
      { rowLabel: 'Review Inspection Results' },
      { rowLabel: 'Receive Final Disbursement' },
    ],
    title: 'Final Disbursement',
  },
];

export const claimDetailsStepDictionary = {
  IsNotSmallClaim: {
    Exception: 4,
    Final: 3,
    Initial: 1,
    Supplemental: 2,
  },
  IsSmallClaim: {
    Exception: 1,
    Final: 1,
    Initial: 1,
    Supplemental: 1,
  },
};

export const DEFAULT_LOSS_DRAFT_CONTACT_INFO = {
  address: {
    content: [
      'Loss Draft Department MS1180',
      '1 Corporate Drive, Suite 360',
      'Lake Zurich, IL 60047-8945',
    ],
    header: 'Mail',
  },
  email: {
    content: 'LossDraft@yourmortgageonline.com',
    header: 'Email',
  },
  fax: {
    content: '1-847-574-7617',
    header: 'Fax',
  },
};

export const FILTER_TAB_LIST = [
  {
    filterId: 'messages',
    filterLabel: 'Messages',
  },
  {
    filterId: 'resources',
    filterLabel: 'Resources',
  },
];

export const MESSAGE_TYPE_CLAIM = 'claim';

export const MESSAGE_TYPE_JIRA = 'message';

export const NEW_CLAIM_INBOX_SUBJECT_LINE = 'New Claim Opened';

export const RESOURCES_DOWNLOAD_LIST = [
  {
    ariaLabel: 'Open Lien Waiver Form in a new browser window',
    documentName: 'Lien Waiver Form',
    fileUrl: 'https://dudhzjl76se9h.cloudfront.net/docs/Lien+Waiver+Form.pdf',
    id: 1,
  },
  {
    ariaLabel: 'Open Third Party Authorization Form in a new browser window',
    documentName: 'Third Party Authorization Form',
    fileUrl: 'https://dudhzjl76se9h.cloudfront.net/docs/Third_Party_Authorization_Form.pdf',
    id: 2,
  },
];

export const RESOURCES_ROW_LIST = [
  {
    label: 'Where to Submit Documents',
    screenToNavigateTo: 'LossDraftWhereToSubmitDocuments',
  },
  {
    label: 'Claims Process Overview',
    screenToNavigateTo: 'LossDraftClaimsProcess',
  },
];

/**
 * drawerHeading -- the heading that displays next to the Back chevron button
 * parentResource -- the pointer to the parent level resource, if none set to ''
 *                   to reset state.
 * resourceTitle -- the main title for the drawer
 */
export const RESOURCES_DRAWER_DETAILS = {
  'Claims Process': { // Displays menu, Main Resource in Claim Center
    drawerHeading: '',
    parentResource: '',
    resourceTitle: 'Claims Process Overview',
  },
  'Receive Final Disbursement': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_RECEIVE_FINAL_DISBURSTMENT,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: 'Receive Final Disbursement',
  },
  'Receive Initial Disbursement': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_RECEIVE_INITIAL_DISBURSTMENT,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: 'Receive Initial Disbursement',
  },
  'Receive Supplemental Disbursement': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_RECEIVE_SUPPLEMENTAL_DISBURSTMENT,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: 'Receive Supplemental Disbursement',
  },
  'Request a Final Disbursement': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_REQUEST_A_FINAL_DISBURSTMENT,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: 'Request Final Disbursement',
  },
  'Request a Supplemental Disbursement': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_REQUEST_A_SUPPLEMENTAL_DISBURSTMENT,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: 'Request Supplemental Disbursement',
  },
  'Request an Inspection': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_REQUEST_AN_INSPECTION,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: 'Request an Inspection',
  },
  'Review Inspection Results': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_REVIEW_INSPECTION_RESULTS,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: 'Review Inspection Results',
  },
  'Submit Contractor(s) Estimate': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_SUBMIT_CONTRACTORS_ESTIMATE,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: "Submit Contractor's Estimate",
  },
  'Submit Insurance Adjusters Report': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_SUBMIT_INSURANCE_ADJUSTERS_REPORT,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: "Submit Insurance Adjuster's Report",
  },
  'Submit Insurance Claims Check': {
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_SUBMIT_INSURANCE_CLAIMS_CHECK,
    drawerHeading: 'Claims Detail',
    parentResource: 'Claims Process',
    resourceTitle: 'Submit Insurance Claims Check',
  },
  'Where to Submit Documents': { // Main Resource on Claim's Center
    detail: INTL_IDS.RESOURCES_DETAIL_TEXT_WHERE_TO_SUBMIT_DOCUMENTS_DESKTOP,
    drawerHeading: 'Claims Resources',
    mobileDetail: {
      text: INTL_IDS.RESOURCES_DETAIL_TEXT_WHERE_TO_SUBMIT_DOCUMENTS_MOBILE,
      ...DEFAULT_LOSS_DRAFT_CONTACT_INFO,
    },
    resourceTitle: 'Where to Submit Documents',
  },
};

export const WHERE_TO_SUBMIT_DOCUMENTS_KEY = 'Where to Submit Documents';
